package com.loyola.acessoescola

import androidx.lifecycle.ViewModel
import com.loyola.acessoescola.services.QuickAuthClient

class AppViewModel(
    val authClient: QuickAuthClient
): ViewModel() {
    fun singout(onSuccessCallBack: () -> Unit, onErrorCallBack: (String?) -> Unit){
        authClient.singout(onSuccessCallBack, onErrorCallBack)
    }
}